<div class="pb-4">
  <div class="name mb-2">
    <em class="mdi mdi-account is-size-5 has-text-grey"></em>
    {{ names | titlecase }}
  </div>

  <form [formGroup]="form">
    <div class="columns">
      <!-- Email -->
      <div
        class="column"
        *ngIf="
          (isAirline$ | async) || (!(pnrInfo$ | async).isDocsRequired && !(isAirline$ | async))
        "
      >
        <app-input-field
          type="text"
          label="{{ 'voluntary-change.' + formType + '.email' | translate }}"
          placeholder="example@mail.com"
          errorMessage="{{ 'dashboard.booking-search.submit-error' | translate }}"
          inputName="email"
          [uppercase]="true"
          [form]="form"
          [submitted]="submitted"
          [tall]="true"
          [isEmail]="activateEmailField"
          (valueChange)="onValueChange()"
        >
        </app-input-field>
      </div>

      <!-- Gender date -->
      <div class="column">
        <app-input-select
          [form]="form"
          size="tall"
          [id]="'gender' + id"
          [translate]="true"
          inputName="gender"
          [value]="firstValueGender"
          [submitted]="submitted"
          (changeOption)="onValueChange()"
          [values]="GENDER_VALUES"
          label="{{ 'voluntary-change.' + formType + '.genre' | translate }}"
          placeholder="{{ 'voluntary-change.' + formType + '.genre.placeholder' | translate }}"
          errorMessage="{{ 'dashboard.booking-search.submit-error' | translate }}"
        >
        </app-input-select>
      </div>

      <!-- birthday date -->
      <div class="column">
        <app-date
          [id]="'birthdayDate' + id"
          [maxDate]="maxDate"
          (sendDate)="birthday = $event; onValueChange()"
          [date]="birthday"
          [minDate]="minDate"
          [submitted]="submitted"
          [error]="!birthday && submitted"
          label="{{ 'voluntary-change.' + formType + '.birthday' | translate }}"
          errorMessage="{{ 'dashboard.booking-search.submit-error' | translate }}"
        >
        </app-date>
      </div>
      <!-- Phone Number -->
      <div
        class="column"
        *ngIf="
          (isAirline$ | async) || (!(pnrInfo$ | async).isDocsRequired && !(isAirline$ | async))
        "
      >
        <app-input-field
          [form]="form"
          type="text"
          [uppercase]="true"
          inputName="phoneNumber"
          [submitted]="submitted"
          (valueChange)="onValueChange()"
          [tall]="true"
          label="{{ 'voluntary-change.' + formType + '.phoneNumber' | translate }}"
          placeholder=""
          errorMessage="{{ 'dashboard.booking-search.submit-error' | translate }}"
        >
        </app-input-field>
      </div>
    </div>
  </form>
</div>
